export class AppConstants {
    static readonly LOCAL_STORAGE_KEY_USER = "user";
    static readonly LOCAL_STORAGE_KEY_PAGES = "pages";
    static readonly LOCAL_STORAGE_KEY_REMEMBER_ME = "rememberMe";
    static readonly LOCAL_STORAGE_KEY_EXPANDED_FORECASTS = "expandedForecasts";
    static readonly LOCAL_STORAGE_KEY_EXPANDED_BUDGET_FORECASTS = "expandedBudgetForecasts";
    static readonly LOCAL_STORAGE_KEY_BUDGET_FORECAST_STATE = "budgetForecastState";
    static readonly FORTNOX = "fortnox";
    static readonly Modules = {
        Fortnox: 'Fortnox',
        ResultSheet: 'ResultSheet'
    };
}